import { Button } from "primereact/button";
import { classNames } from "primereact/utils";
import { Badge } from "primereact/badge";
import { Tooltip } from "primereact/tooltip";

// Custom components
import NoData from "../NoData";

// Utils
import { calendarListTypes, formatOrgCalDate, hasPendingChange, pendingChangeTooltip, requestModalModeOptions, rescheduleCancellationTooltip } from "./utils";

//Styles
import myStyles from "../../styles/appointments/Appointments.module.css"

export default function AppointmentsCalendarAppointments({
  type,
  filteredAppointments,
  filteredAppointmentsALL,
  openEditModal,
  openDeleteConfirmation,
  openCancelConfirmation,
  loadingAppointmentsSmall,
  getOrgNameFromMap,
}) {
  function RenderTooltipIcon(target, tooltipText) {
    return (
      <div className={myStyles.infoWithTooltip}>
        <Tooltip target={target} />
        <i
          id={target.replace("#", "")}
          className="pi pi-info-circle"
          style={{ fontSize: '1.2rem' }}
          data-pr-tooltip={tooltipText}
          data-pr-position="left"
        />
      </div>
    )

  }

  function getActionButtons(appointment) {
    //Check if appointment status indicates a pending change
    let _hasPendingChange = hasPendingChange(appointment)

    //Check if future dated recurring instance has pending change
    if (type === calendarListTypes.upcoming && !appointment.isRecurring && appointment.id.includes("recurring")) {
      const hasMatchingPendingRequest = filteredAppointmentsALL?.pending?.some(appt => appt.appointmentId === appointment.id)
      if (hasMatchingPendingRequest) {
        _hasPendingChange = true
      }
    }

    switch (type) {
      case calendarListTypes.upcoming:
        return (
          <div className="flex flex-row flex-wrap gap-2">
            {(_hasPendingChange) && (
              RenderTooltipIcon(`#change_button_info_${appointment.id}`, pendingChangeTooltip)
            )}
            <Button
              label="Change"
              className={classNames(myStyles.calenderListButton, myStyles.roundedDialogButton)}
              onClick={() => openEditModal(appointment, requestModalModeOptions.change)}
              disabled={_hasPendingChange || loadingAppointmentsSmall}
            />
            <Button
              label="Cancel"
              severity="secondary"
              className={classNames(myStyles.calenderListButton, myStyles.roundedDialogButton)}
              disabled={_hasPendingChange || loadingAppointmentsSmall}
              onClick={() => openCancelConfirmation(appointment)}
            />
          </div>
        )

      case calendarListTypes.pending:
        return (
          <div className="flex flex-row flex-wrap gap-2">
            {(appointment.type === "RESCHEDULE" || appointment.type === "CANCELLING") && (
              RenderTooltipIcon(`#change_button_info_${appointment.id}`, rescheduleCancellationTooltip.replace("[TYPE]", appointment.type))
            )}
            {(appointment.type === null) && (
              RenderTooltipIcon(`#change_button_info_${appointment.id}`, pendingChangeTooltip)
            )}
            <Button
              label="Edit"
              className={classNames(myStyles.calenderListButton, myStyles.roundedDialogButton)}
              onClick={() => openEditModal(appointment, requestModalModeOptions.edit)}
              disabled={appointment.type !== "NEW" || loadingAppointmentsSmall} // Disable edit if not a "NEW" type request.
            />
            <Button
              label="Delete"
              severity="secondary"
              className={classNames(myStyles.calenderListButton, myStyles.roundedDialogButton)}
              onClick={() => openDeleteConfirmation(appointment)}
              disabled={loadingAppointmentsSmall}
            />
          </div>
        )

      default:
        return null // No action buttons for past, pending, or declined appointments.
    }
  }

  return (
    <div className={myStyles.calendarViewApptsContainer}>
      {filteredAppointments?.length === 0 && (
        <NoData
          title={"Nothing here... yet"}
          subTitle={"Data will be displayed here when available"}
        />
      )}

      {filteredAppointments.map((appt, i) => {
        return (
          <div
            key={i}
            className={myStyles.calendarViewAppts}
          >
            <b className="flex flex-row gap-1 flex-wrap">
              {appt.engagementType}
              <br />
              {appt.scheduledTime}
            </b>

            {appt.isRecurring && (
              <div className="flex flex-row gap-2 flex-wrap">
                <span>
                  {`${formatOrgCalDate(appt, "recurringStartDate")} - ${formatOrgCalDate(appt, "recurringEndDate")}`}
                </span>
                <Badge value="Recurring" />
              </div>
            )}

            <div className="flex flex-column gap-0">
              <div className="flex flex-row gap-1 flex-wrap mb-0">
                with
                <span className={myStyles.purpleText}>{appt.staff}</span>
              </div>

              <div className="flex flex-row gap-1 flex-wrap mt-0">
                from
                <span className={myStyles.purpleText}>{getOrgNameFromMap(appt.orgId)}</span>
              </div>
            </div>

            {(appt.type && appt.type !== "NEW") && (
              <div>
                <Badge value={appt.type} />
              </div>
            )}

            {getActionButtons(appt)}

            {i < filteredAppointments.length - 1 && (
              <hr className="mt-3 mb-3" />
            )}
          </div>
        )
      })}
    </div>
  );
}